import { motion } from "framer-motion";
import { Zap, Flame, FileSearch } from "lucide-react";
import { useLang } from "@/lib/lang";
import { Reveal, Eyebrow, EASE } from "./Reveal";

const META = [
  { img: "/img/electricity.jpg", Icon: Zap, span: "lg:col-span-7 lg:row-span-2", h: "min-h-[440px] lg:min-h-0" },
  { img: "/img/gas.jpg", Icon: Flame, span: "lg:col-span-5", h: "min-h-[320px]" },
  { img: "/img/office.jpg", Icon: FileSearch, span: "lg:col-span-5", h: "min-h-[320px]" },
];

const Card = ({ it, m, i }) => (
  <motion.article initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }} transition={{ duration: 0.9, delay: i * 0.1, ease: EASE }} className={`group relative overflow-hidden rounded-[24px] border border-line ${m.span} ${m.h}`} data-testid={`category-card-${i}`}>
    <img src={m.img} alt={it.t} className="absolute inset-0 h-full w-full object-cover grayscale-[60%] transition-[transform,filter] duration-[1.2s] ease-out group-hover:scale-105 group-hover:grayscale-0" />
    <div className="absolute inset-0 bg-gradient-to-t from-bg via-bg/80 to-bg/20" />
    <div className="relative flex h-full flex-col justify-between p-7 sm:p-9">
      <div className="flex items-center justify-between">
        <span className="rounded-full border border-line bg-bg/60 px-3 py-1 font-mono text-[11px] uppercase tracking-[0.18em] text-ink backdrop-blur">{it.tag}</span>
        <span className="grid h-11 w-11 place-items-center rounded-full bg-gold text-bg transition-transform duration-500 group-hover:rotate-[-12deg]"><m.Icon size={18} /></span>
      </div>
      <div className="mt-24">
        <h3 className={`font-display font-medium leading-tight text-ink ${i === 0 ? "text-3xl sm:text-5xl" : "text-2xl sm:text-3xl"}`}>{it.t}</h3>
        <p className="mt-4 max-w-lg text-zinc-300">{it.d}</p>
      </div>
    </div>
  </motion.article>
);

export const Categories = () => {
  const { t } = useLang();
  const c = t.categories;
  return (
    <section id="categorii" className="section" data-testid="categories-section">
      <div className="container-x">
        <Reveal><Eyebrow>{c.eyebrow}</Eyebrow></Reveal>
        <Reveal delay={0.05}><h2 className="h2 mt-6">{c.title}</h2></Reveal>
        <div className="mt-14 grid grid-cols-1 gap-5 lg:auto-rows-[minmax(340px,auto)] lg:grid-cols-12">
          {c.items.map((it, i) => <Card key={it.t} it={it} m={META[i]} i={i} />)}
        </div>
      </div>
    </section>
  );
};
